import { cn } from '@/lib/utils'

interface TableFallbackProps {
  content: string
  className?: string
}

/**
 * Simple fallback component for when table rendering fails
 * Provides user-friendly error message in German
 */
export function TableFallback({ content, className }: TableFallbackProps) {
  return (
    <div className={cn(
      'border border-yellow-200 bg-yellow-50 dark:border-yellow-800 dark:bg-yellow-900/20 rounded-md p-4',
      className
    )}>
      <div className="text-sm text-yellow-800 dark:text-yellow-200 mb-3 font-medium">
        ⚠️ Tabelle konnte nicht korrekt dargestellt werden
      </div>
      <details className="group">
        <summary className="cursor-pointer text-xs text-yellow-700 dark:text-yellow-300 hover:text-yellow-900 dark:hover:text-yellow-100 mb-2">
          Ursprünglichen Inhalt anzeigen
        </summary>
        <pre className="text-xs bg-yellow-100 dark:bg-yellow-900/40 p-3 rounded overflow-auto max-h-64 whitespace-pre-wrap font-mono">
          {content}
        </pre>
      </details>
    </div>
  )
}

/**
 * More severe error fallback for complete rendering failures
 */
export function ErrorFallback({ content, className }: TableFallbackProps) {
  return (
    <div className={cn(
      'border border-red-200 bg-red-50 dark:border-red-800 dark:bg-red-900/20 rounded-md p-4',
      className
    )}>
      <div className="text-sm text-red-800 dark:text-red-200 mb-3 font-medium">
        ❌ Markdown-Parsing komplett fehlgeschlagen
      </div>
      <pre className="text-xs bg-red-100 dark:bg-red-900/40 p-3 rounded overflow-auto max-h-64 whitespace-pre-wrap font-mono">
        {content}
      </pre>
    </div>
  )
}